import { calculateNextRun } from './calculator.js';
export function previewNextRuns(input) {
    const count = input.count ?? 10;
    const runs = [];
    let lastRunAt;
    let referenceDate = input.startDate;
    for (let i = 0; i < count; i += 1) {
        const scheduleInput = {
            scheduleType: input.scheduleType,
            scheduleConfig: input.scheduleConfig,
            timezone: input.timezone,
            startDate: input.startDate,
            referenceDate,
        };
        if (input.startDateLocal) {
            scheduleInput.startDateLocal = input.startDateLocal;
        }
        if (input.endDate) {
            scheduleInput.endDate = input.endDate;
        }
        if (lastRunAt) {
            scheduleInput.lastRunAt = lastRunAt;
        }
        const result = calculateNextRun(scheduleInput);
        if (!result.nextRunAt) {
            break;
        }
        runs.push(result.nextRunAt);
        lastRunAt = result.nextRunAt;
        referenceDate = result.nextRunAt;
    }
    return runs;
}
//# sourceMappingURL=preview.js.map